import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { WSQueryConfig } from "@ws-react-query";
import { useWSQuery } from "../../helpers";
import { WSServiceError } from "../../../utils/serviceHelper";
import { getRequirement } from "../../../services/requirements/getRequirement";
import { QUERY_REQUIREMENT } from "../keys";

export const useQueryRequirement = (
  requirementId: string,
  config?: WSQueryConfig<IRequirementResponse, WSServiceError>
) =>
  useWSQuery(
    [QUERY_REQUIREMENT, requirementId],
    () => getRequirement(requirementId),
    config
  );
